import { useLayoutEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

export default function HashScroll() {
  const { hash } = useLocation();
  const navType = useNavigationType();

  useLayoutEffect(() => {
    if (!hash) return;

    // On back/forward, let browser restore scroll
    if (navType === "POP") return;

    const id = hash.slice(1);

    requestAnimationFrame(() => {
      // Check if we're on desktop (lg breakpoint = 1024px)
      if (id === "application-form" && window.innerWidth >= 1024) {
        const desktopEl = document.getElementById("application-form-desktop");
        if (desktopEl) {
          desktopEl.scrollIntoView({ behavior: "smooth", block: "start" });
          return;
        }
      }

      const el = document.getElementById(id);
      if (!el) return;
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  }, [hash, navType]);

  return null;
}
